module.exports = __webpack_public_path__ + "static/media/newOrder.5980ab75.mp3";